<script>
import * as acessofuncionalidade from '@/api/acessofuncionalidade'

export default {
  props: {
    mode: { type: String, default: 'tab' }
  },
  data () {
    return {
      title: 'Listar Acesso Funcionalidade',
      modal: {
        component: 'app-acessofuncionalidade-edit',
        width: 300,
        field: 'descricao'
      },
      backend: acessofuncionalidade
    }
  }
}
</script>

<template>
  <simple-crud-grid :title="title" :mode="mode" :modal="modal" :backend="backend" @save="(data) => $emit('save', data)" />
</template>
